import React from 'react';
import './ResumePreview.css';

const ResumePreview = ({ data }) => {
  const { personalInfo, summary, experience, education, skills, certifications } = data;

  return (
    <div className="preview-card">
      <div className="preview-header">
        <h3>📄 Resume Preview</h3>
        <span className="preview-badge">Live Preview</span>
      </div>

      <div className="preview-content">
        <div className="resume-preview">
          {/* Header */}
          <div className="resume-header">
            <h1 className="resume-name">
              {personalInfo.fullName || 'Your Name'}
            </h1>
            <div className="resume-contact">
              {personalInfo.email && <span>{personalInfo.email}</span>}
              {personalInfo.phone && <span>{personalInfo.phone}</span>}
              {personalInfo.location && <span>{personalInfo.location}</span>}
            </div>
            {personalInfo.portfolio && (
              <div className="resume-portfolio">
                <span className="portfolio-label">Portfolio:</span>
                <span className="portfolio-link">{personalInfo.portfolio}</span>
              </div>
            )}
            {personalInfo.linkedin && (
              <div className="resume-links">
                <span>{personalInfo.linkedin}</span>
              </div>
            )}
          </div>

          {/* Professional Summary */}
          {summary && (
            <div className="resume-section">
              <h2 className="resume-section-title">PROFESSIONAL SUMMARY</h2>
              <div className="resume-section-line"></div>
              <p className="resume-summary">{summary}</p>
            </div>
          )}

          {/* Work Experience */}
          {experience.length > 0 && (
            <div className="resume-section">
              <h2 className="resume-section-title">PROFESSIONAL EXPERIENCE</h2>
              <div className="resume-section-line"></div>
              {experience.map((exp, index) => (
                <div key={index} className="resume-entry">
                  <div className="resume-entry-header">
                    <strong className="resume-job-title">{exp.jobTitle || 'Job Title'}</strong>
                    <strong className="resume-company">{exp.company || 'Company Name'}</strong>
                  </div>
                  <div className="resume-entry-meta">
                    {(exp.startDate || exp.endDate) && (
                      <span className="resume-dates">
                        {exp.startDate || 'Start'} - {exp.endDate || 'End'}
                      </span>
                    )}
                    {exp.location && <span>{exp.location}</span>}
                  </div>
                  {exp.responsibilities && exp.responsibilities.length > 0 && exp.responsibilities.some(r => r.trim()) && (
                    <ul className="resume-list">
                      {exp.responsibilities.filter(resp => resp.trim()).map((item, i) => (
                        <li key={i}>{item.trim()}</li>
                      ))}
                    </ul>
                  )}
                  {exp.description && !exp.responsibilities && (
                    <ul className="resume-list">
                      {exp.description.split('\n').filter(line => line.trim()).map((item, i) => (
                        <li key={i}>{item.trim()}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Education */}
          {education.length > 0 && (
            <div className="resume-section">
              <h2 className="resume-section-title">EDUCATION</h2>
              <div className="resume-section-line"></div>
              {education.map((edu, index) => (
                <div key={index} className="resume-entry">
                  <div className="resume-entry-header">
                    <strong className="resume-degree">{edu.degree || 'Degree'}</strong>
                    <strong className="resume-school">{edu.school || 'School Name'}</strong>
                  </div>
                  <div className="resume-entry-meta">
                    {edu.graduationDate && <span>{edu.graduationDate}</span>}
                    {edu.location && <span>{edu.location}</span>}
                    {edu.gpa && <span>GPA: {edu.gpa}</span>}
                  </div>
                  {edu.link && (
                    <div className="resume-link">
                      <a href={edu.link} target="_blank" rel="noopener noreferrer">
                        🔗 Verification Link
                      </a>
                    </div>
                  )}
                  {edu.honors && (
                    <p className="resume-honors">{edu.honors}</p>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Skills */}
          {skills.length > 0 && (
            <div className="resume-section">
              <h2 className="resume-section-title">SKILLS</h2>
              <div className="resume-section-line"></div>
              {skills.map((skill, index) => (
                <div key={index} className="resume-skill-entry">
                  {skill.category && (
                    <span className="resume-skill-category">{skill.category}: </span>
                  )}
                  <span className="resume-skill-items">{skill.items || 'Skills...'}</span>
                </div>
              ))}
            </div>
          )}

          {/* Certifications */}
          {certifications.length > 0 && (
            <div className="resume-section">
              <h2 className="resume-section-title">CERTIFICATIONS</h2>
              <div className="resume-section-line"></div>
              {certifications.map((cert, index) => (
                <div key={index} className="resume-cert-entry">
                  <strong className="resume-cert-name">{cert.name || 'Certification Name'}</strong>
                  <div className="resume-cert-meta">
                    {cert.issuer && <span>{cert.issuer}</span>}
                    {cert.date && <span>{cert.date}</span>}
                  </div>
                  {cert.link && (
                    <div className="resume-link">
                      <a href={cert.link} target="_blank" rel="noopener noreferrer">
                        🔗 View Certificate
                      </a>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Empty State */}
          {!personalInfo.fullName && 
           !summary && 
           experience.length === 0 && 
           education.length === 0 && 
           skills.length === 0 && 
           certifications.length === 0 && (
            <div className="resume-empty-state">
              <p className="empty-icon">📝</p>
              <p className="empty-text">Start filling out the form to see your resume preview</p>
            </div>
          )}
        </div>
      </div>

      <div className="preview-footer">
        <div className="ats-indicator">
          <span className="ats-badge">✓ ATS Optimized</span>
          <span className="ats-info">
            This format is designed to pass through Applicant Tracking Systems
          </span>
        </div>
      </div>
    </div>
  );
};

export default ResumePreview;
